import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { Close } from "@/components/icons/close";
import { ShareVideo as ShareVideoIcon } from "@/components/icons/share-video";
import useViewportContext from "@/hooks/use-viewport-context";

type InfoBarProps = {
  title?: string;
  onClose: () => void;
  onShareClick?: () => void;
};

export const InfoBar = (props: InfoBarProps) => {
  const { title = "", onClose, onShareClick } = props;
  const { viewport } = useViewportContext();
  /** No ViewportProvider on published Content Hub → `viewport` undefined; treat as desktop. */
  const isDesktop = (viewport ?? "desktop") === "desktop";
  const { t } = useTranslation();

  return (
    <BarContainer>
      <Heading>{title}</Heading>
      <div
        className={`flex items-center gap-2 ${
          onShareClick ? "flex-row-reverse" : ""
        }`}
      >
        <button
          type="button"
          onClick={onClose}
          className="flex cursor-pointer items-center gap-2 rounded border-0 bg-[#2c3242] p-2.5 text-white hover:bg-[#393b41]"
        >
          <span className={isDesktop ? "sr-only" : ""}>
            {t("common.close")}
          </span>
          <Close className="size-6 shrink-0 text-white" aria-hidden />
        </button>
        {onShareClick ? (
          <button
            type="button"
            onClick={onShareClick}
            className="box-border inline-flex min-h-10 min-w-10 cursor-pointer items-center justify-center gap-1.5 rounded border-0 bg-[#2c3242] px-3 py-2.5 font-sans text-sm font-medium leading-5 text-white hover:bg-[#393b41]"
          >
            <ShareVideoIcon
              className="size-4 shrink-0 text-white"
              aria-hidden
            />
            <span
              className={`whitespace-nowrap text-sm font-medium leading-5 text-white ${
                isDesktop ? "" : "sr-only"
              }`}
            >
              {t("content-hub.preference-panel.share")}
            </span>
          </button>
        ) : null}
      </div>
    </BarContainer>
  );
};

const BarContainer = withViewportStyle("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${(props) => props.$viewport.tablet`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 16px;
  `}
`;

const Heading = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: white;
  max-width: 80%;
`;
